import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import ORG_TYPES from '../../../../../../constants/types/OrganisationTypes';

import { selectOrganisation } from '../../../../../../redux/selectors/organisation';

import styles from './overview.module.scss';
import Avatar from '../../../../../../components/Avatar/Avatar';
import UIButton from '../../../../../../components/UIButton';
import FlexColumn from '../../../../../../components/FlexBox/FlexColumn';
import SButton from '../../../../../../components/SButton/SButton';
import FlexRow from '../../../../../../components/FlexBox/FlexRow';

const OverviewCard = ({
  displayDeleteModal,
  displayEditCustomerModal,
  displayPartnerHandoverModal,
}) => {
  const { organisation } = useSelector((state) => ({
    organisation: selectOrganisation(state),
  }));

  const [admin, setAdmin] = useState({});
  const [org, setOrg] = useState({});

  useEffect(() => {
    if (organisation) {
      const { generalSetting } = organisation;
      const { admins: adm } = generalSetting;
      const type = organisation?.handoverStatus === 1 ? 2 : 1;
      const index = adm?.findIndex((admins) => admins?.adminType === type);

      if (index !== -1 && adm && adm[index]) {
        setAdmin(adm[index]);
      } else {
        const indexi = adm?.findIndex((admins) => admins?.adminType === 1);
        if (indexi !== -1 && adm && adm[indexi]) {
          setAdmin(adm[indexi]);
        } else {
          setAdmin({});
        }
      }

      setOrg(generalSetting);
    }
  }, [organisation]);

  const topSection = () => {
    return (
      <div className={styles['top_section']}>
        <Avatar name={org?.name} img="" size="small" />
        <div className={styles['text_container']}>
          <h2>{org?.name || ''}</h2>
          <p>{ORG_TYPES[org?.type] || ''}</p>
          <span>{org.country || ''}</span>
        </div>
      </div>
    );
  };

  const handOverStatusRender = (value) => {
    let status;
    switch (value) {
      case 1:
        status = <p style={{ color: 'green' }}>Complete</p>;
        break;
      case 0:
        status = <p style={{ color: 'red' }}>Pending</p>;
        break;
      default:
        status = '';
        break;
    }

    return status;
  };

  const bottomSection = () => {
    return (
      <div className={styles['bottom_section']}>
        <div className={styles['column']}>
          <p className={styles['label']}>Name</p>
          <p className={styles['text']}>{admin && admin.name ? admin.name : ''}</p>
        </div>
        <div className={styles['column']}>
          <p className={styles['label']}>Email</p>
          <p className={styles['text']}>{admin && admin.email ? admin.email : ''}</p>
        </div>
        <div className={styles['column']}>
          <p className={styles['label']}>Phone</p>
          <p className={styles['text']}>{admin && admin.phone ? admin.phone : ''}</p>
        </div>
        {organisation?.saamsIntegration && (
          <div className={styles['column']}>
            <p className={styles['label']}>Handover Status</p>
            <p className={styles['text']}>{handOverStatusRender(organisation?.handoverStatus)}</p>
          </div>
        )}
        <FlexRow flexWrap="nowrap">
          <SButton style={{ whiteSpace: 'nowrap' }} fullWidth color={"grey"} onClick={displayDeleteModal}>Delete Customer</SButton>
          <SButton style={{ whiteSpace: 'nowrap' }} fullWidth onClick={displayEditCustomerModal}>Edit Customer</SButton>
        </FlexRow>
        {organisation?.handoverStatus === 0 && organisation?.saamsIntegration && <SButton fullWidth onClick={displayPartnerHandoverModal} darkColor={true} style={{ marginTop: '1rem' }}>Partner Handover</SButton>}
      </div>
    );
  };

  return (
    <div className={styles['container']}>
      {topSection()}
      <div className={styles['border']}></div>
      {bottomSection()}
    </div>
  );
};

export default OverviewCard;
